import { useContext } from "react";
import { SnapshotService } from "src/services/useSnapshot.service/useSnapshot.service";

export const useSnapshot = () => useContext(SnapshotService);
